import { search } from '../../Foundation';

export class ProductFilter {
  /**
   * Creates an instance where user can manipulate with a textfield (number)
   * @param {HTMLElement} element input element
   */
  constructor(element) {
    // Name, reference
    element.ProductFilter = this;

    // Elements
    this._refs = {
      input: document.querySelector('.product-search input[type="text"]'),
      options: element.querySelector('.product-filter__options'),
      filters: Array.from(element.querySelectorAll('.form-select select')),
      filteritems: Array.from(element.querySelectorAll('.product-filter__list-item i')),
      category: document.querySelector('.selectedNode a'),
      featurefilter: document.querySelectorAll('.product-features-filter input[type="checkbox"]'),
      featurefilterselected: Array.from(
        document.querySelectorAll('.product-features-filter input[type="checkbox"]'),
      ).filter((i) => i.checked),
      allCategories: document.querySelectorAll('.product-tree table a'),
      clearAllFilters: document.querySelector('.product-filter__link'),
      productDeckItems: Array.from(document.querySelectorAll('#mainform .product-deck__item')),
    };

    // Events
    this._refs.filters.forEach((x) =>
      x.addEventListener('change', this._onFilterItemChange.bind(this)),
    );
    this._refs.filteritems.forEach((x) =>
      x.addEventListener('click', this._onClickRemoveFilter.bind(this)),
    );
    this._refs.featurefilter.forEach((x) =>
      x.addEventListener('change', this._featurefilterCheckboxChange.bind(this)),
    );
    this._refs.allCategories.forEach((x) =>
      x.addEventListener('click', this._onCategoryChange.bind(this)),
    );
    this._refs.clearAllFilters !== null
      ? this._refs.clearAllFilters.addEventListener('click', this._onClearFilters.bind(this))
      : '';
    this._refs.productDeckItems.forEach((x) =>
      x.addEventListener('click', this._onFilterProductDeckItem.bind(this)),
    );
  }

  get searchObject() {
    let searchObject = {
      phrase: this._refs.input.value || searchObject?.phrase,
      category: this._refs.category?.getAttribute('href')?.split('filterByCategory:')[1] ?? '',
      filters: this._refs.filters,
      featurefilters: this._refs.featurefilterselected,
    };
    return searchObject;
  }

  _searchQuery(searchObject) {
    search.execute({
      phrase: searchObject.value || searchObject?.phrase,
      category: searchObject.category ?? '',
      filters: searchObject.filters,
      featurefilters: searchObject.featurefilters,
    });
  }

  _onFilterProductDeckItem(event) {
    if (event.currentTarget.firstElementChild.href.endsWith('ordering/spareparts/housing')) {
      return;
    }

    event.preventDefault();
    const text = document.querySelector('.product-search input[type="text"]').value;
    const textWithParam = text ? '$search!' + text : '';
    const url = event.currentTarget.firstChild.nextSibling.href + textWithParam;

    window.open(url.trim(), '_self');
  }

  /**
   * onFilterItemChange
   * When user selects dedicated filter values
   * @param {Event} e - event interface
   */
  _onFilterItemChange() {
    // Overlay
    const oBackdrop = document.createElement('div');
    oBackdrop.setAttribute('class', 'fade in');
    oBackdrop.setAttribute('id', 'progress-backdrop');

    // Spinner
    const oSpinner = document.createElement('div');
    oSpinner.setAttribute('id', 'progress');
    oSpinner.innerHTML = '<i class="eva eva-loader-outline" aria-hidden="true"></i>';

    // Inject backdrop and spinner
    const oBody = document.getElementsByTagName('body')[0];

    oBody.appendChild(oBackdrop);
    oBody.appendChild(oSpinner);

    this._searchQuery(this.searchObject);
  }

  /**
   * onClickRemoveFilter
   * Remove a filter when user clicks on "x" inside item
   * @param {Event} e - Event interface
   */
  _onClickRemoveFilter(e) {
    const getFilterName = e.target.parentElement.dataset.filtertype;

    // Filters
    this._refs.filters.forEach((select) => {
      const getFilterValue = e.target.parentElement.innerText.split(':')[1]?.trim();
      //brand = na parent od klasata type- ostatokot
      Array.from(select.options).forEach((option) => {
        if (option?.value === getFilterValue && option?.dataset.brand == getFilterName) {
          option.selected = false;
          option.removeAttribute('selected');
        }
      });
    });

    // Feature Filters
    this._refs.featurefilterselected.forEach((element) => {
      const getFilterValue = e.target.parentElement.innerText.split(':')[1]?.trim();
      if (
        element.dataset.productFieldName == getFilterName &&
        element.dataset.filterValue == getFilterValue
      ) {
        this._refs.featurefilterselected.indexOf(element) > -1
          ? this._refs.featurefilterselected.splice(element)
          : '';
      }
    });

    // Check for type
    if (e.target.parentElement.classList.contains('type-search')) {
      this._refs.input.value = '';
    }

    this._searchQuery({
      ...this.searchObject,
      phrase: this._refs.input.value,
    });
  }

  _featurefilterCheckboxChange(e) {
    if (e.srcElement.checked) {
      this._refs.featurefilterselected.push(e.srcElement);
    } else if (e.srcElement.checked == false) {
      this._refs.featurefilterselected.indexOf(e.srcElement) > -1
        ? this._refs.featurefilterselected.splice(e.srcElement)
        : '';
      // remove it from filters if the filter also exists in the top right filters
      const getFilterValue = e.srcElement.dataset.productFieldName;
      this._refs.filters.forEach((select) => {
        Array.from(select.options).forEach((option) => {
          if (option?.dataset.brand == getFilterValue) {
            option.selected = false;
            option.removeAttribute('selected');
          }
        });
      });
    }
    this._onFilterItemChange();
  }

  /**
   * onCategoryChange
   * Remove all filters on change of category
   */
  _onCategoryChange(event) {
    this._refs.filters.forEach((select) => {
      Array.from(select.options).forEach((option) => {
        option.selected = false;
        option.removeAttribute('selected');
      });
    });
    sessionStorage.setItem('allFiltersButton', 'closed');

    this._searchQuery({
      ...this.searchObject,
      category: event.currentTarget.getAttribute('href').split('filterByCategory:')[1],
    });
  }

  _onClearFilters() {
    sessionStorage.setItem('allFiltersButton', 'closed');
  }
}
